import { FeatureAppDefinition, FeatureServices, Logger } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import React from 'react';
import { App } from './app';
import { FeatureServicesContext } from './use-feature-services';
import dependencies from './dependencies.json';
import { HistoryServiceV2 } from '@feature-hub/history-service';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { ThemeProvider } from '@volkswagen-onehub/components-core';
import { CommonFeatureAppConfig, initializeFetchJson } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
// @ts-ignore
import type { BffResponse } from '@onlinebooking/bff';
import { BrandProvider, BrandState } from "./modules/contexts/brand-context/BrandProvider";

export interface OnlinebookingFeatureAppDependencies extends FeatureServices {
  readonly 's2:history': HistoryServiceV2;
  readonly 's2:logger'?: Logger;
  readonly 'service-config-provider': ServiceConfigProviderV1;
  readonly tracking: TrackingManagerV1;
}

export const featureAppDefinition: FeatureAppDefinition<ReactFeatureApp, OnlinebookingFeatureAppDependencies, CommonFeatureAppConfig> = {
  ...dependencies,

  create: (env) => {
    const { config, featureServices } = env;

    const { 's2:logger': logger = console } = featureServices;

    overrideVwdataPageName();

    // initialize the mock server and mock ids
    initializeFetchJson('onlinebooking', logger, config);

    return {
      // eslint-disable-next-line react/display-name
      render: () => {
        return (
          <FeatureServicesContext.Provider value={featureServices}>
            <ThemeProvider theme="main">
              <BrandProvider initialBrand={detectInitialBrand()}>
                <App />
              </BrandProvider>
            </ThemeProvider>
          </FeatureServicesContext.Provider>
        );
      },
    };
  },
};

export default featureAppDefinition;

function detectInitialBrand(): BrandState {
  const path = window.location.pathname.toLowerCase();

  if (path.startsWith('/audi')) {
    return BrandState.Audi;
  }

  return BrandState.Vw;
}

function overrideVwdataPageName() {
  const override = (vwdata: any) => {
    const original = vwdata.push.bind(vwdata);
    vwdata.push = (ev: any) => {
      if (ev?.eventInfo?.pageName !== undefined) {
        ev.eventInfo.pageName = document.title;
      }
      return original(ev);
    };
  };

  if ((window as any).vwdata) {
    override((window as any).vwdata);
  } else {
    let _vwdata: any;
    Object.defineProperty(window, 'vwdata', {
      configurable: true,
      get: () => _vwdata,
      set: (val) => { _vwdata = val; override(val); }
    });
  }
}
